import React, { useEffect, useState } from "react";
import { Button, Divider, Grid, IconButton, InputAdornment, Modal, Paper, TextField, Typography, Link, Menu, MenuItem,  ListItemText, FormControlLabel, Checkbox } from "@mui/material";
import { useTheme } from '@mui/material/styles';

import { PostData } from "../interfaces/post.interface";

import {ReactComponent as LikeIcon} from '../assets/images/posts/like.svg';
import {ReactComponent as LikeCounterIcon} from '../assets/images/posts/like-counter.svg';

import {ReactComponent as SendMessageIcon} from '../assets/images/posts/send-message.svg';
// import image8 from '../assets/images/posts/imagen-8.png';
import ImageProfileCircle from "./ImageProfileCircle";
import { buildMediaUrl } from "../utils/media-files";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../store";
import { getPostsCommentRequest, setPostsCommentRequest, setPostsReactionRequest } from "../api/employeePortal";
import { setPostComment, setPostReaction } from "../store/slices/posts";
import DocumentViewer from "./DocumentViewer";
import { getDatestring } from "../utils/date";

import MoreVertIcon from '@mui/icons-material/MoreVert';

interface PostCardProps { 
    postData: PostData;
    setErrorMsg: (value: string) => void;
    setSuccessMsg: (value: string) => void;
    disableElevation?: boolean;
    onlyView?: boolean;
}

const PostCard = ({postData, setErrorMsg, setSuccessMsg, disableElevation, onlyView}: PostCardProps) => {
    const {companyselected} = useSelector((state: RootState) => state.auth);
    const dispatch = useDispatch<AppDispatch>();
    const [createdLocalTime, setCreatedLocalTime] = useState<string | undefined>();
    const [sinceLocalTime, setSinceLocalTime] = useState<string | undefined>();
    const [untilLocalTime, setUntilLocalTime] = useState<string | undefined>();
    const theme = useTheme();
    // const [focused, setFocused] = useState(false);
    const [loading, setLoading] = useState(false);
    const [comment, setComment] = useState("");
    const [imageUrl, setImageUrl] = useState("");
    const [documentUrl, setDocumentUrl] = useState("");
    const [documentUrlViwer, setDocumentUrlViwer] = useState("");
    const [commentsList, setCommentsList] = useState<any[]>([]);
    const [authorizationLevelName, setAuthorizationLevelName] = useState<any[]>([]);
    const [isModalOpen, setIsModalOpen] = useState(false); 
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [userIsAdmin, setUserIsAdmin] = useState(false);
    const open = Boolean(anchorEl);

    

    useEffect(() => {
        if (!companyselected) return;
        const managementOption = companyselected?.Roles?.Access
                                    .find(m => m.Name === "Gestión");
        const hasAppoveOption = companyselected?.Roles?.Access
                                    .find(m => m.Name === "Publicaciones" && m.ParentId === managementOption?.SecurityAccessId);
        setUserIsAdmin(!!hasAppoveOption);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companyselected]);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
};

    const handleChange = (event: any) => {
        setComment(event.target.value);
    };

    const toggleModal = () => setIsModalOpen(!isModalOpen);

    useEffect(() => {
        if (postData.createdAt) {
            const date = getDatestring(new Date(postData.createdAt * 1000), '-', false);    
            setCreatedLocalTime(`Publicado el ${date}`);
        }
        if (postData?.availableUntil) {
            const date = getDatestring(new Date(postData?.availableUntil * 1000), '-', false);     
            setUntilLocalTime(date);
        }
        if (postData?.availableSince) {
            const date = getDatestring(new Date(postData?.availableSince * 1000), '-', false);        
            setSinceLocalTime(date);
        }
        if (postData.mediaUrls?.length) {
            const validImages = ["jpg", "png", "gif", "jpeg",];
            const image = postData.mediaUrls.find(i => validImages.includes(i.split(".")[1]));
            setImageUrl(image ? buildMediaUrl(image) : "");
            const pdfFile = postData.mediaUrls.find(i => ["pdf"].includes(i.split(".")[1]));
            setDocumentUrl(pdfFile ? buildMediaUrl(pdfFile) : "");
        }
        if (postData.authorizationLevelName?.length) {
            if (typeof postData.authorizationLevelName === "string") {
                setAuthorizationLevelName([postData.authorizationLevelName]);
            } else {
                setAuthorizationLevelName(postData.authorizationLevelName);
            }
        }
    }, [postData]);

    useEffect(() => {
        if (commentsList.length || !isModalOpen || !companyselected?.Code) {
            return;
        }
        getPostComments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isModalOpen, companyselected?.Code])

    const getPostComments = async() => {
        const result = await getPostsCommentRequest({...postData, postType: "post"});
        if (result.status !== 200 || !result?.data?.message?.Items) {
            setErrorMsg("No fue posible obtener los comentarios");
            return;
        }
        setCommentsList(result.data.message.Items)
    }

    const handlerSetPostReaction = async () => {
        setLoading(true);
        const result = await setPostsReactionRequest(companyselected?.Token || "", {
            postType: "post",
            "orderTimestamp-ID": postData["orderTimestamp-ID"],
        });
        if (result?.status === 200) {
            const liked = result.data.message === "reaccion agregada";
            dispatch(setPostReaction({
                postType: "post",
                "orderTimestamp-ID": postData["orderTimestamp-ID"],
                hasLiked: liked,
            }));
            setSuccessMsg(result.data.message || (liked ? "reaccionaste" : "eliminaste tu reaccion"));
        } else {
            setErrorMsg(result?.data?.message || result?.data || "Ocurrio un error por favor reintenta.");
        }
        setLoading(false);
    };

    const handlerSetComment = async () => {
        setLoading(true);
        const result = await setPostsCommentRequest(companyselected?.Token || "", {
            postType: "post",
            "orderTimestamp-ID": postData["orderTimestamp-ID"],
            text: comment
        });
        if (result?.status === 200) {
            dispatch(setPostComment({
                postType: "post",
                "orderTimestamp-ID": postData["orderTimestamp-ID"],
                text: comment,
            }));
            setSuccessMsg("Tu comentario fue envíado");
            setComment("");
            await getPostComments()
        } else {
            setErrorMsg(result?.data?.message || result?.data || "Ocurrio un error por favor reintenta.");
        }
        setLoading(false);
    };


    return (
        <>
            <Paper 
                elevation={disableElevation ? 0 : 3}
                style={{
                    width: "100%", 
                    borderRadius: "0.5rem",
                    padding: "1.5rem",
                    backgroundColor: postData.approvalStatus === "rejected" ? "#FFB3B3" : undefined,
                    position: 'relative'
                }}
            >
                {(userIsAdmin || postData.createdById === companyselected?.Code) && <div style={{
                    position: "absolute",
                    top: "0.5rem",
                    right: "0.5rem"
                }}>
                    <IconButton
                        aria-label="more"
                        aria-controls="long-menu"
                        aria-haspopup="true"
                        onClick={handleClick}
                        size="small"
                        style={{
                            backgroundColor: "rgba(0, 0, 0, 0.04)",
                            color: theme.s10palette.S10Greygrey500
                        }}
                    >
                        <MoreVertIcon fontSize="small" />
                    </IconButton>
                    
                    <Menu
                        id="long-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={open}
                        onClose={handleClose}
                        PaperProps={{
                            style: {
                                maxHeight: 48 * 4.5,
                                width: '30ch',
                            },
                        }}
                    >
                        <MenuItem onClick={handleClose}>
                            <FormControlLabel
                                value="start"
                                control={<Checkbox
                                    disabled={true}
                                    checked={postData.allowComments}
                                />}
                                label="Permitir comentarios"
                                // labelPlacement="start"
                            />
                        </MenuItem>
                        <MenuItem onClick={handleClose}>
                            <FormControlLabel
                                value="start"
                                control={<Checkbox
                                    disabled={true}
                                    checked={!!untilLocalTime}
                                />}
                                label="Con vigencia?"
                                // labelPlacement="start"
                            />
                        </MenuItem>
                        <MenuItem value={0}>
                            <ListItemText primary={`Aprobado por: ${postData.approvedByName}`} />
                        </MenuItem>
                        <Divider />
                        <MenuItem value={0}>
                            <ListItemText primary="Visible para" />
                        </MenuItem>
                        {!authorizationLevelName?.length 
                            ? <MenuItem key={"Todos"} value={"Todos"}>
                                <Checkbox checked={true} disabled={true} />
                                <ListItemText primary={"Todos"} />
                            </MenuItem>
                            : authorizationLevelName?.map((name) => (
                                <MenuItem key={name} value={name}>
                                    <Checkbox checked={true} disabled={true} />
                                    <ListItemText primary={name} />
                                </MenuItem>
                            ))
                        }
                    </Menu>
                </div>}



                <Grid container width={"100%"} direction={"column"}>
                <Grid container item width={"100%"} direction={"row"}>
                    <Grid 
                        item 
                        style={{
                            width: "2.5rem",
                            height: "2.5rem",
                        }}
                    >
                        <ImageProfileCircle 
                            width="2.5rem"
                            height="2.5rem"
                            userId={postData.createdById}
                            ruc={postData.ruc}
                            userName={postData.createdByName}
                        />
                    </Grid>
                    <Grid 
                        container
                        direction="column"
                        justifyContent="center"
                        item 
                        alignItems="flex-start"
                        style={{
                            flex: 1,
                            width: "100%",
                            marginLeft: ".5rem"
                        }}
                    >
                        <Grid item>
                            <Typography variant="h6" color={theme.s10palette.S10Greygrey700} style={{fontSize: ".8rem", margin: 0}}>
                                {postData.createdByName}
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant="subtitle2" 
                                style={{
                                    color: theme.s10palette.S10Greygrey500,
                                    fontSize: "0.7rem",
                                }}
                            >
                                {createdLocalTime}
                            </Typography>
                            
                            {sinceLocalTime && untilLocalTime &&
                                <Typography variant="subtitle2" 
                                    style={{
                                        color: theme.s10palette.S10Greygrey500,
                                        fontSize: "0.7rem",
                                    }}
                                >
                                    Disponible del {sinceLocalTime} al {untilLocalTime}
                                </Typography>
                            }
                        </Grid>
                    </Grid>
                </Grid>
            <Divider style={{
                    width: "100%", 
                    marginTop: "1rem", 
                    marginBottom: "1rem",
                    color: "#E8E8E8",
                }}
            />
            <Grid container item>
                <Typography variant="subtitle1" 
                    style={{
                        color: theme.s10palette.S10Greygrey500,
                    }}
                >
                    {postData.text}
                </Typography>
            </Grid>
            {documentUrl && <>
                <Divider style={{
                        width: "100%", 
                        marginTop: "1rem", 
                        marginBottom: "1rem",
                        color: "#E8E8E8",
                    }}
                />
                <Grid container item>
                    <Typography variant="subtitle2" style={{color: theme.s10palette.S10Greygrey500, margin: "0 .25rem"}}>
                        <Link
                            component='div'
                            onClick={() => 
                                setDocumentUrlViwer(documentUrl)
                            }
                        >
                            Ver documento
                        </Link>
                    </Typography> 
                </Grid>
            </>}
            {imageUrl && <Grid container item style={{marginTop: "1rem"}}>
                <img 
                    src={imageUrl}
                    alt={postData.postId}
                    style={{
                        // backgroundColor: theme.s10palette.S10Greygrey100,
                        width: "100%",
                        height: "80%",
                        // backgroundSize: "cover",
                    }}
                />
            </Grid>}
                <Divider 
                    style={{
                        width: "100%", 
                        marginTop: "1rem", 
                        color: "#E8E8E8",
                    }}
                />
                    
                    {!onlyView && (
                        <Grid container item direction="row" justifyContent="space-between">
                            <Button 
                                style={{
                                    color: theme.s10palette.S10Blueblue600,
                                    fontSize: "0.875rem",
                                    fontWeight: "500",
                                    height: "2.5rem",
                                    padding: ".5rem"
                                }}
                                disabled={loading}
                                startIcon={<LikeIcon style={{height: "1.5rem", width: "1.5rem"}} />}
                                onClick={loading ? undefined : handlerSetPostReaction}
                            >
                                {postData.hasLiked ? 'Reaccionaste' : 'Reaccionar'}
                            </Button>
                            <Button 
                                style={{
                                    color: theme.s10palette.S10Greygrey500,
                                    fontSize: "0.75rem",
                                    fontWeight: "400",
                                    height: "2.5rem",
                                    padding: ".5rem"
                                }}
                                startIcon={<LikeCounterIcon style={{ height: "1.5rem", width: "1.5rem" }} />}
                            >
                                {`${postData?.reactions?.like || 0}`} Reacciones
                            </Button>
                            <Button
                                style={{
                                    color: theme.s10palette.S10Greygrey500,
                                    fontSize: "0.75rem",
                                    fontWeight: "400",
                                    height: "2.5rem",
                                    padding: ".5rem"
                                }}
                                // startIcon={<CommentIcon style={{ height: "1.5rem", width: "1.5rem" }} />}
                                onClick={postData.allowComments !== false 
                                            ? toggleModal
                                            : undefined
                                        }
                                disabled={postData.allowComments === false}
                            >
                                {`${postData?.comments || 0}`} Comentarios
                            </Button>
                        </Grid>
                    )}
                    
                    <Divider style={{ width: "100%", marginBottom: "1rem", color: "#E8E8E8" }} />
                    
                    {!onlyView && postData.allowComments !== false && (
                        <Grid container item width={"100%"} direction={"row"} alignContent="center" alignItems="center">
                            <TextField
                                fullWidth
                                placeholder="Escribe un comentario..."
                                variant="outlined"
                                onClick={toggleModal}
                                // onFocus={handleFocus}
                                // onBlur={handleBlur}
                                value={comment}
                                onChange={handleChange}
                            />
                        </Grid>
                    )}
                </Grid>
            </Paper>

            <DocumentViewer
                handleClose={() => setDocumentUrlViwer("")}
                documentUrl={documentUrlViwer}
            />
            <Modal open={isModalOpen && postData.allowComments !== false} onClose={toggleModal}>
                <Paper style={{ width: "80%", margin: "auto", marginTop: "5%", padding: "1rem" }}>
                    <Typography variant="h6" gutterBottom>Comentarios</Typography>
                    <Divider />
                    <div style={{ maxHeight: "60vh", overflowY: "auto", marginTop: "1rem" }}>
                        {commentsList?.map((c: any, index: any) => (
                            <Grid 
                                key={`${c["orderTimestamp-ID"]}-${c.createdAt}`}
                                container 
                                item 
                                style={{marginTop: "1rem", width: "100%"}} 
                                direction={"row"}
                            >
                                <ImageProfileCircle 
                                    width="2.5rem"
                                    height="2.5rem"
                                    ruc={c.ruc}
                                    userId={c.createdByUserId}
                                    userName={c.createdByUserName}
                                />
                                <Grid
                                    container
                                    direction="column"
                                    justifyContent="center"
                                    alignItems="flex-start"
                                    item 
                                    style={{
                                        flex: 1,
                                        width: "100%",
                                        marginLeft: ".5rem"
                                    }}
                                >
                                    <Typography variant="subtitle2" color={theme.s10palette.S10Greygrey700} >
                                        {c.createdByUserName}
                                    </Typography>
                                    <Typography variant="subtitle1" fontSize={"0.75rem"} color={theme.s10palette.S10Greygrey500}>
                                        {c.text}
                                    </Typography>
                                </Grid>
                            </Grid>
                        ))}
                    </div>
                    <TextField
                        fullWidth
                        placeholder="Escribe un comentario..."
                        variant="outlined"
                        value={comment}
                        onChange={handleChange}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={handlerSetComment} disabled={loading}>
                                        <SendMessageIcon />
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                        style={{ marginTop: "1rem" }}
                    />
                </Paper>
            </Modal>
        </>
    );
};

export default PostCard;
